/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { AppContext } from '../../context/AppContextProvider'
import { SalesType } from '../../util/constants'
import { detectMacOs, detectNumberCount, formatAndRoundPrize } from '../../util/util'
import MobileNumber from './MobileNumber'
import OtpNumber from './OtpNumber'
import { ModalContext } from '../../context/ModalContextProvider'
import { MessageHandlerContext } from '../../context/MessageHandlerContextProvider'
import { AuthContext } from '../../context/AuthContextProvider'
import PurchaseConfirm from './PurchaseConfirm'
import NICNumber from './NICNumber'
import PurchaseComplete from './PurchaseComplete'
import CountDown from '../../components/CountDown'
import 'bootstrap/dist/css/bootstrap.min.css'

const LottoBaseHome = () => {
  const { lotto } = useParams()
  const { lotteryState, setLotteryState, setPackageState, setSalesType } = useContext(AppContext)
  const { globalLoader, themeState, setThemeState } = useContext(MessageHandlerContext)
  const { authState } = useContext(AuthContext)
  const {
    mobileNumberModal, setMobileNumberModal,
    otpModal, setOtpModal,
    nicModal, setNicModal,
    purchaseCompleteModal, setPurchaseCompleteModal,
    purchaseConfirmModal, setPurchaseConfirmModal
  } = useContext(ModalContext)

  const formattedPrize = formatAndRoundPrize(lotteryState && lotteryState.jackpot)
  const spacing = detectNumberCount(formattedPrize.amount)

  useEffect(() => {
    setTheme()
  }, [])

  const setTheme = () => {
    switch (lotto) {
      case 'Govi Setha':
        setThemeState('gs')
        setLotteryState({ jackpot: window.env.GS_JACKPOT_PRICE, drawId: window.env.GS_DRAW_ID, draw_number: window.env.GS_DRAW, draw_date: window.env.GS_DRAW_DATE, draw_date_time: window.env.GS_DRAW_END_TIME })
        setPackageState(window.env.GS_PACKAGE_ID)
        break
      case 'Supiri Vasana':
        setThemeState('sw')
        setLotteryState({ jackpot: window.env.SW_JACKPOT_PRICE, drawId: window.env.SW_DRAW_ID, draw_number: window.env.SW_DRAW, draw_date: window.env.SW_DRAW_DATE, draw_date_time: window.env.SW_DRAW_END_TIME })
        setPackageState(window.env.SW_PACKAGE_ID)
        break
      case 'Mahajana Sampatha':
        setThemeState('ms')
        setLotteryState({ jackpot: window.env.MS_JACKPOT_PRICE, drawId: window.env.MS_DRAW_ID, draw_number: window.env.MS_DRAW, draw_date: window.env.MS_DRAW_DATE, draw_date_time: window.env.MS_DRAW_END_TIME })
        setPackageState(window.env.MS_PACKAGE_ID)
        break
      case 'Dhana Nidhanaya':
        setThemeState('dn')
        setLotteryState({ jackpot: window.env.DN_JACKPOT_PRICE, drawId: window.env.DN_DRAW_ID, draw_number: window.env.DN_DRAW, draw_date: window.env.DN_DRAW_DATE, draw_date_time: window.env.DN_DRAW_END_TIME })
        setPackageState(window.env.DN_PACKAGE_ID)
        break
      case 'Mega Power':
        setThemeState('mp')
        setLotteryState({ jackpot: window.env.MP_JACKPOT_PRICE, drawId: window.env.MP_DRAW_ID, draw_number: window.env.MP_DRAW, draw_date: window.env.MP_DRAW_DATE, draw_date_time: window.env.MP_DRAW_END_TIME })
        setPackageState(window.env.MP_PACKAGE_ID)
        break
      case 'Vasana Sampatha':
        setThemeState('ws')
        setLotteryState({ jackpot: window.env.WS_JACKPOT_PRICE, drawId: window.env.WS_DRAW_ID, draw_number: window.env.WS_DRAW, draw_date: window.env.WS_DRAW_DATE, draw_date_time: window.env.WS_DRAW_END_TIME })
        setPackageState(window.env.WS_PACKAGE_ID)
        break
      case 'Hadahana':
        setThemeState('hd')
        setLotteryState({ jackpot: window.env.HD_JACKPOT_PRICE, drawId: window.env.HD_DRAW_ID, draw_number: window.env.HD_DRAW, draw_date: window.env.HD_DRAW_DATE, draw_date_time: window.env.HD_DRAW_END_TIME })
        setPackageState(window.env.HD_PACKAGE_ID)
        break
      case 'Jathika Sampatha':
        setThemeState('js')
        setLotteryState({ jackpot: window.env.JS_JACKPOT_PRICE, drawId: window.env.JS_DRAW_ID, draw_number: window.env.JS_DRAW, draw_date: window.env.JS_DRAW_DATE, draw_date_time: window.env.JS_DRAW_END_TIME })
        setPackageState(window.env.JS_PACKAGE_ID)
        break
      case 'Lucky 7':
        setThemeState('l7')
        setLotteryState({ jackpot: window.env.L7_JACKPOT_PRICE, drawId: window.env.L7_DRAW_ID, draw_number: window.env.L7_DRAW, draw_date: window.env.L7_DRAW_DATE, draw_date_time: window.env.L7_DRAW_END_TIME })
        setPackageState(window.env.L7_PACKAGE_ID)
        break
      case 'Ada Sampatha':
        setThemeState('as')
        setLotteryState({ jackpot: window.env.AS_JACKPOT_PRICE, drawId: window.env.AS_DRAW_ID, draw_number: window.env.AS_DRAW, draw_date: window.env.AS_DRAW_DATE, draw_date_time: window.env.AS_DRAW_END_TIME })
        setPackageState(window.env.AS_PACKAGE_ID)
        break
      default:
        break
    }
  }
  const onBuyClick = (type) => {
    setSalesType(type)
    if (authState && authState.token) {
      setPurchaseConfirmModal(!purchaseConfirmModal)
    } else {
      setMobileNumberModal(!mobileNumberModal)
    }
  }

  const renderMegaPowerLottery = () => {
    return (
      // for the new requirement add new ui to new background (2023/07/22)
      <div className="py-2">
        <div className='lottery-wrapper'>
          {/* <div className='winning-prize-wrapper'>
          {spacing !== 0 && <div className='winning-prize-currency' style={{ top: spacing.top, left: spacing.left }}>Rs</div>}
          <div className='draw-info'>
            DRAW {lotteryState && lotteryState.draw_number} | DATE {lotteryState && lotteryState.draw_date}
          </div>
          <div className='winning-prize-amount' style={{ top: detectMacOs() ? -22 : -7 }}>
            {formattedPrize.amount}
          </div>
          <div className='winning-prize-suffix' style={{ bottom: detectMacOs() ? -16 : -22 }}>
            {formattedPrize.suffix}
          </div>
        </div> */}

{/* //Thia Change because of the new requarment */}
          <div className='MegapowerDrawText'>
            DRAW {lotteryState && lotteryState.draw_number} | DATE {lotteryState && lotteryState.draw_date}
          </div>
          <div className='MegapowerPriceText'>
          {formattedPrize.amount} {formattedPrize.suffix}
          </div>

          {/* <Container>
            <Row>
              <Col xs="7"></Col>
              <Col xs="5">
                <div className=''>
                  <CountDown />
                </div>
              </Col>
            </Row>
          </Container> */}
          <div className='buttonforMP'>
            <button
              className='buttonInsideforMP'
              onClick={() => {
                onBuyClick(SalesType.ON_DEMAND)
              }}
            >
              BUY
            </button>
          </div>
        </div>
      </div>
    )
  }
  const renderLottery = () => {
    // Check if the current lotto is "Mega Power"
    if (lotto === 'Mega Power') {
      return renderMegaPowerLottery()
    }
    // Render the default UI for other lotteries
    return (
      <div className="py-2">
        <div className='lottery-wrapper'>
          <div className='winning-prize-wrapper'>
            {spacing !== 0 && <div className='winning-prize-currency' style={{ top: spacing.top, left: spacing.left }}>Rs</div>}
            <div className='draw-info'>
              DRAW {lotteryState && lotteryState.draw_number} | DATE {lotteryState && lotteryState.draw_date}
            </div>
            <div className='winning-prize-amount' style={{ top: detectMacOs() ? -22 : -7 }}>
              {formattedPrize.amount}
            </div>
            <div className='winning-prize-suffix' style={{ bottom: detectMacOs() ? -16 : -22 }}>
              {formattedPrize.suffix}
            </div>
          </div>
          <div className='countdown-wraper-container'>
            <CountDown />
          </div>
          <div className={'button'}>
            <button
              className={`buy-button ${themeState}`}
              style={{ paddingTop: detectMacOs() ? 2 : 4 }}
              onClick={() => {
                onBuyClick(SalesType.ON_DEMAND)
              }}
            >
              BUY NOW
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="pos-rel h-100">
      {
        !globalLoader && renderLottery()
      }
      {/* <div className="logo_lucky1">
        <img src={lucky1Logo} />
      </div> */}
      <MobileNumber opened={mobileNumberModal} toggle={() => setMobileNumberModal(!mobileNumberModal)} />
      <OtpNumber opened={otpModal} toggle={() => setOtpModal(!otpModal)} />
      <NICNumber opened={nicModal} toggle={() => setNicModal(!nicModal)} />
      <PurchaseConfirm opened={purchaseConfirmModal} toggle={() => setPurchaseConfirmModal(!purchaseConfirmModal)} />
      <PurchaseComplete opened={purchaseCompleteModal} toggle={() => setPurchaseCompleteModal(!purchaseCompleteModal)} />
    </div>
  )
}

export default LottoBaseHome
